var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandbags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.55 12.46a.31.31 0 0 0-.45-.12c-.56.25.65 5.57.85 5.85a.34.34 0 0 0 .6 0c.26-.52-.55-5.1-1-5.73Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.64 12.44c-.25-.07-.37.08-.44.34-.2.8.72 2.72 1.38 4.13a.33.33 0 0 0 .33.33c1.09 0-1-4.76-1.27-4.8Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.22 16.79a11 11 0 0 0-2.08-2.7c-1.45-1.25-1.7 0-1.16.1s1.24 1 1.61 1.51c.84 1.1 1.59 2.22.54 3.7a7.36 7.36 0 0 1-3.26 2.24 21.12 21.12 0 0 1-6.37 1.08c-2.85.19-6.39.42-9-.87s-2.7-4.07-1.04-6.43a4.25 4.25 0 0 1 1.37-1.48.29.29 0 0 0 .11-.45c1.78.16 4.13-3.09 10.94-2.3 3.77.44 3.07 1.73 4.21 2.17a2.19 2.19 0 0 0 2.57-1 2.55 2.55 0 0 0-.58-2.1A6.09 6.09 0 0 0 17 7.38c.57-.6-1.16-5-2-5.84-3.16-3.1-9-1.2-10 2.88a10.53 10.53 0 0 0-.3 2.87l0 1.61c0 .41.15.1-.35.38-1.44.8-2.64 3.57-.84 4.14A4.49 4.49 0 0 0 1.92 15c-2 2.66-2 6 1.15 7.71 2.88 1.55 6.28 1.33 9.5 1.13a20 20 0 0 0 6.69-1.28c2.59-1.09 5-3.15 3.96-5.77ZM5.82 4.67c1.08-3.34 6-4.7 8.56-2.41a10.57 10.57 0 0 1 2 4.89.3.3 0 0 0 .05.16 30.2 30.2 0 0 0-10.9 1.45 8.36 8.36 0 0 0-.12-1.47 9.77 9.77 0 0 1 .41-2.62Zm-1.1 5.21a16.62 16.62 0 0 1 5-1.27 23.64 23.64 0 0 1 6.55-.24c3 .27 4.5 3.22 4.36 3.62-.05.15-.25.21-.44.26-1.54.48-.32-1.66-5.16-2.1a25 25 0 0 0-5.77.2 6.75 6.75 0 0 0-2.05.76c-.67.41-2.52 2.2-3.56 1.55-.74-.43-.01-2.23 1.07-2.78Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74 17.11a.42.42 0 0 0 .74.25c.22-.52 1-2.31 1.6-3.67.28-.95-.78-1-1.24.1A7.43 7.43 0 0 0 7 16a4 4 0 0 0-.26 1.11Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandbags);
export default __webpack_public_path__ + "static/media/handbags.7ee50891af1992443f2c830ed35e2294.svg";
export { ForwardRef as ReactComponent };